import { useUserProfile } from './useUserProfile';

/** Acceso a administración de usuarios / perfiles (`manage:users` vía GET /me). */
export const useCanManageUsers = (): boolean => {
  const { hasEffectiveAccess } = useUserProfile();
  return hasEffectiveAccess('create:user');
};
